import * as React from "react";
import { Radio as AntdRadio } from "antd";

const AntDRadioGroup = AntdRadio.Group;

interface IRadioGroup {
  className?: string;
  value: any;
  handleChange: (e?: any) => any;
}

interface IRadio {
  className?: string;
  checked?: boolean;
  handleChange: (e?: any) => any;
  label: string;
  value: any;
}

class RadioGroup extends React.Component<IRadioGroup, any> {
  render() {
    let { className, value, handleChange } = this.props;
    return (
      <AntdRadio.Group
        className={className}
        value={value}
        onChange={handleChange}
      >
        {this.props.children}
      </AntdRadio.Group>
    );
  }
}

class Radio extends React.Component<any, any> {
  render() {
    let { handleChange, className, label, checked, value } = this.props;
    return (
      <AntdRadio
        className={className}
        checked={checked}
        value={value}
        onChange={handleChange}
      >
        {label}
      </AntdRadio>
    );
  }
}

export { RadioGroup };
export default Radio;



// WEBPACK FOOTER //
// ./client/modules/form/Radio/index.tsx